import {Arc} from '@app/modules/svg/model/path/curve/arc/Arc';
import {CBezier} from '@app/modules/svg/model/path/curve/bezier/cubic/CBezier';
import {SCBezier} from '@app/modules/svg/model/path/curve/bezier/cubic/SCBezier';
import {QBezier} from '@app/modules/svg/model/path/curve/bezier/quadratic/QBezier';
import {SQBezier} from '@app/modules/svg/model/path/curve/bezier/quadratic/SQBezier';
import {HLineTo} from '@app/modules/svg/model/path/line/oriented/HLineTo';
import {VLineTo} from '@app/modules/svg/model/path/line/oriented/VLineTo';
import {LineTo} from '@app/modules/svg/model/path/line/LineTo';
import {MoveTo} from '@app/modules/svg/model/path/point/MoveTo';
import {PathCommand} from '@app/modules/svg/model/path/PathCommand';

export function fromJSON(type: string, content: any): PathCommand | undefined {
  let pathCommand: PathCommand | undefined;

  switch (type) {
    case Arc.name:
      pathCommand = new Arc(
        content._rx,
        content._ry,
        content._x_axis_rotation,
        content._large_arc_flag,
        content._sweep_flag,
        content._point,
        content.close,
        content.absolute,
      );
      break;

    case CBezier.name:
      pathCommand = new CBezier(
        content.c_point0,
        content.c_point1,
        content.point,
        content.close,
        content.absolute,
      );
      break;
    case SCBezier.name:
      pathCommand = new SCBezier(
        content.c_point0,
        content.point,
        content.close,
        content.absolute,
      );
      break;
    case QBezier.name:
      pathCommand = new QBezier(
        content.c_point,
        content.point,
        content.close,
        content.absolute,
      );
      break;
    case SQBezier.name:
      pathCommand = new SQBezier(
        content.point,
        content.close,
        content.absolute,
      );
      break;

    case HLineTo.name:
      pathCommand = new HLineTo(
        content.point,
        content.close,
        content.absolute,
      );
      break;
    case VLineTo.name:
      pathCommand = new VLineTo(
        content.point,
        content.close,
        content.absolute,
      );
      break;

    case LineTo.name:
      pathCommand = new LineTo(
        content._point,
        content.close,
        content.absolute
      );
      break;

    case MoveTo.name:
      pathCommand = new MoveTo(
        content.point,
        content.close,
        content.absolute,
      );
      break;
  }

  return pathCommand;
}
